import { ACTION_TYPES } from "./Actions";
import { TOAST_VARIANTS } from "Helpers/toastVariant";

const initState = {
	toast: {
		enable: false,
		message: "",
		variant: TOAST_VARIANTS.INFO,
		title: "",
		// Bumped on every toast so the banner remounts and replays its
		// entry animation / progress bar even for a repeated message.
		id: 0,
		QuizSound: true,
	},
};

const Reducer = (state = initState, action) => {
	switch (action.type) {
		case ACTION_TYPES.TOAST_MESSAGE_ENABLE:
			return {
				...state,
				toast: {
					enable: true,
					message: action.message,
					variant: action.variant || TOAST_VARIANTS.INFO,
					title: action.title || "",
					id: (state.toast?.id || 0) + 1,
				},
			};

		case ACTION_TYPES.TOAST_MESSAGE_DISABLE:
			return {
				...state,
				// Keep message/variant so the banner fades out with its content
				// intact instead of emptying mid-transition.
				toast: {
					...state.toast,
					enable: false,
				},
			};

		case ACTION_TYPES.QUIZ_SOUND:
			return {
				...state,
				QuizSound: action.QuizSound,
			};

		default:
			return state;
	}
};

export default Reducer;
